





















































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Event } from "@/api/models/Event";

@Component
export default class CalendarEventDialog extends Vue {
    /**
     * If the dialog is open or not.
     */
    @PropSync("open")
    _open: boolean;

    /**
     * Event to display inside the dialog.
     */
    @Prop()
    event: Event;
}
